import React, { useState, useEffect, useCallback } from "react";
import { useMediaQuery, Pagination, download, Toast } from "../../Components";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Table,
  TableBody,
  TableHead,
  TableContainer,
  Paper,
  TableCell,
  TableRow,
} from "@mui/material";
import { utils } from "../../Helpers";
import OpportunitiesItem from "./OpportunitiesItem";
import { engagementService } from "../../Services";
import { campaignsApplicationService } from "../../Services/campaignApplication.service";
import ModalOpportunitySecond from "../../Components/ModalOpportunitySecond";
import { ROUTES } from "../../Components/Constants/routesConstant";
import { useNavigate } from "react-router-dom";
import {AccountSelect} from "../../Components/AccountSelect";

export default function Opportunities(props) {
  const navigate = useNavigate();
  const [isloaded, setIsLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(true); // New loading state for initial load and status changes
  const [modal, setModal] = useState(null);
  const [featuredOpportunities, setFeaturedOpportunities] = useState([]);
  const [opportunities, setOpportunities] = useState([]);
  console.log("🚀 ~ Opportunities ~ opportunities:", opportunities);
  const [paginationData, setPaginationData] = useState({});
  const [page, setPage] = useState(1);
  const [toastList, setToastList] = useState([]);
  const width = useMediaQuery();
  const [modalData, setModalData] = useState(null);
  const [max, setMax] = useState(null);
  const [accountCount, setAccountCount] = useState(0);

  const [showApplyModal, setShowApplyModal] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [showProfileIncompleteModal, setShowProfileIncompleteModal] =
    useState(false);
  const [applicationNote, setApplicationNote] = useState("");
  const [isApplying, setIsApplying] = useState(false);
  const [campaignStatus, setCampaignStatus] = useState("active");
  const [mediaAccounts, setMediaAccounts] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState("");
  const [proposedRate, setProposedRate] = useState("");
  const [rateCurrency, setRateCurrency] = useState("USD");

  // const perPage = 5;

  const transformApiData = (apiData, status) => {
    if (apiData.data && Array.isArray(apiData.data)) {
      return apiData.data
        .filter(
          (item) => item.status === (status === "active" ? "open" : "closed")
        )
        .map((item) => ({
          id: item.id,
          brand_profile_id: item.brand_profile_id,
          profile_ready: item.profile_ready,
          brand_name: item.brand_name,
          deadline_date: item.apply_by_date || "N/A",
          description: item.scope_of_work || "No description",
          budget: item.compensation || "TBD",
          title: item.title || "Campaign",
          delivery_date: item.delivery_date || "N/A",
          delivery_info: item.delivery_info || "TBD",
          additional_info: item.additional_info || "",
          platform: item.platform || "IG",
          category: item.category || "general",
          reach_min: item.reach_min || 0,
          engagement_min: item.engagement_min || 0,
          location: item.location || "Global",
          status: item.status || "open",
          application_count: item.application_count || 0,
          created_date: item.created_at || new Date().toISOString(),
          updated_at: item.updated_at || new Date().toISOString(),
          files: item.files || [],
          application_status: item.application_status,
          // handle: {
          //   icon: ["instagram"],
          //   handle: "@campaign_" + item.id,
          // },
        }));
    }

    // Fallback for paginated data structure
    if (apiData.data && apiData.data.data && Array.isArray(apiData.data.data)) {
      return apiData.data.data
        .filter(
          (item) => item.status === (status === "active" ? "open" : "closed")
        )
        .map((item) => ({
          id: item.id,
          profile_ready: item.profile_ready,
          brand_profile_id: item.brand_profile_id,
          brand_name: item.brand_name,
          deadline_date: item.apply_by_date,
          description: item.scope_of_work,
          budget: item.compensation,
          title: item.title,
          delivery_date: item.delivery_date,
          delivery_info: item.delivery_info,
          additional_info: item.additional_info,
          platform: item.platform,
          category: item.category,
          reach_min: item.reach_min,
          engagement_min: item.engagement_min,
          location: item.location,
          status: item.status,
          application_count: item.application_count,
          files: item.files,
          created_date: item.created_at || new Date().toISOString(),
          updated_at: item.updated_at || new Date().toISOString(),
          application_status: item.application_status,
          handle: {
            icon: ["instagram"],
            // handle: "@campaign_" + item.id,
          },
        }));
    }

    return [];
  };

  const addToast = useCallback((data) => {
    setToastList((prev) => [
      ...prev,
      { ...data, id: `${Date.now()}-${prev.length}` },
    ]);
  }, []);

  // Function to open apply modal
  const openApplyModal = (campaign) => {
    setModal(null); // Close the opportunity details modal first
    setTimeout(() => {
      setSelectedCampaign(campaign);
      setApplicationNote("");
      setSelectedAccount("");
      setProposedRate("");
      setRateCurrency("USD");
      setShowApplyModal(true);
    }, 150); // 300ms delay for smooth transition
  };

  // Function to close apply modal
  const closeApplyModal = () => {
    setShowApplyModal(false);
    setSelectedCampaign(null);
    setApplicationNote("");
    setSelectedAccount("");
    setProposedRate("");
    setRateCurrency("USD");
    setIsApplying(false);
  };

  const closeProfileModal = () => {
    setShowProfileIncompleteModal(!showProfileIncompleteModal);
  };

  // Function to handle campaign application
  const handleApplyCampaign = async () => {
    if (!selectedCampaign || !applicationNote.trim() || !selectedAccount) {
      addToast({
        error: true,
        msg: "Please select an account and enter a note for your application",
      });
      return;
    }

    setIsApplying(true);

    try {
      const payload = {
        note: applicationNote.trim(),
        platform_id: selectedAccount.social_media_id,
        social_user_id: selectedAccount.pt_user_id,
        rate: proposedRate ? parseFloat(proposedRate) : null,
        rate_currency: rateCurrency,
      };

      console.log("payload", payload);

      const res = await campaignsApplicationService.applyCampaignApplication(
        selectedCampaign.id,
        payload
      );
      console.log("applyCampaignApplication", res);

      addToast({
        error: false,
        msg: `Successfully applied to "${selectedCampaign.title}" campaign!`,
      });

      closeApplyModal();
    } catch (error) {
      console.error("Error applying to campaign:", error);
      addToast({
        error: true,
        msg: "Failed to apply to campaign. Please try again.",
      });
    } finally {
      setIsApplying(false);
      fetchData();
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, width, addToast, campaignStatus]);

  async function fetchData() {
    try {
      setIsLoading(true);
      setIsLoaded(false);

      // const res = await campaignsApplicationService.getApplications();
      const res = await campaignsApplicationService.getInfOpportunities(
        campaignStatus === "active" ? "active" : "past"
      );
      console.log("Applications API response:", res);

      const transformedData = transformApiData(res, campaignStatus);
      setOpportunities(transformedData);

      // Set pagination data based on API response structure
      if (res.meta && res.meta.pagination) {
        setPaginationData(res.meta.pagination);
      } else if (res.data && res.data.current_page) {
        setPaginationData({
          current_page: res.data.current_page,
          per_page: res.data.per_page,
          total: res.data.total,
          total_pages: res.data.last_page,
        });
      } else {
        // Default pagination for direct array response
        setPaginationData({
          current_page: 1,
          per_page: transformedData.length,
          total: transformedData.length,
          total_pages: 1,
        });
      }

      setAccountCount(1);

      // Set featured opportunities from open campaigns
      let featuredOpportunities = transformedData.slice(0, 3); // Take first 3 as featured

      const max =
        width <= 1180 && featuredOpportunities.length > 2
          ? 2
          : featuredOpportunities.length > 3
          ? 3
          : featuredOpportunities.length;
      setMax(max);

      setFeaturedOpportunities(featuredOpportunities.slice(0, max));

      setIsLoaded(true);
    } catch (err) {
      console.error("Error fetching campaigns:", err);
      addToast({
        error: true,
        msg: "Failed to load campaigns: " + (err.message || err),
      });
      setIsLoaded(true);
    } finally {
      setIsLoading(false);
    }
  }

  const handleStatusChange = (status) => {
    setCampaignStatus(status);
    setPage(1); // Reset to first page when changing status
  };

  const onPaginate = (page) => {
    setPage(page);
  };

  // const updateOnCollaborate = async () => {
  //   try {
  //     const res = await engagementService.getCampaignsByInfluencer({
  //       page: page,
  //       pageSize: perPage,
  //     });
  //     setOpportunities(res["data"]);
  //     const resFeatured = await engagementService.getCampaignsByInfluencer({
  //       page: page,
  //       pageSize: perPage,
  //     });
  //     let featuredOpportunities = resFeatured["data"].filter(
  //       (item) => item.is_featured && item.is_featured === 1
  //     );
  //     if (featuredOpportunities.length === 0) {
  //       featuredOpportunities = resFeatured["data"];
  //     }
  //     const max =
  //       width <= 1180 && featuredOpportunities.length > 2
  //         ? 2
  //         : featuredOpportunities.length > 3
  //         ? 3
  //         : featuredOpportunities.length;
  //     setMax(max);
  //     setFeaturedOpportunities(featuredOpportunities.splice(0, max));
  //     if (res["meta"] && res["meta"]["pagination"]) {
  //       setPaginationData(res["meta"]["pagination"]);
  //     }
  //     setIsLoaded(true);
  //   } catch (err) {
  //     addToast({
  //       error: true,
  //       msg: err,
  //       id: `${Date.now()}-${toastList.length}`,
  //     });
  //   }
  // };

  // const deleteCard = (id) => {
  //   setOpportunities(opportunities.filter((item) => item.id !== id));
  // };
  const downloadCsv = async () => {
    try {
      let options = {
        page: page,
        pageSize: 10,
        fileType: "csv",
      };
      const response = await engagementService.getCampaignsByInfluencer(
        options
      );
      utils.downloadFile(response, "opportunity_page_" + page + ".csv");
    } catch (err) {
      addToast({
        error: true,
        msg: err,
        id: `${Date.now()}-${toastList.length}`,
      });
    }
  };

  useEffect(() => {
    if (showApplyModal) getMediaAccounts();
  }, [showApplyModal]);

  const getMediaAccounts = async () => {
    try {
      // const res = await engagementService.getAllMediaAccounts(
      //   "social_media_id=42"
      // );
      const res = await engagementService.getAllMediaAccounts(
        `social_media_code=${selectedCampaign.platform}`
      );
      if (res.success === true) {
        setMediaAccounts(res.data);
        console.log("🚀 ~ getMediaAccounts ~ res.data:", res.data);
        if (res?.data?.length === 1) {
          setSelectedAccount(res?.data[0]);
        } else {
          setSelectedAccount(null);
        }
      }
    } catch (err) {
      addToast({ error: true, date: new Date(), msg: err.message });
    }
  };

  // const maxPlaceholder = width <= 1180 ? 2 : 3;

  return (
    <div className="main">
      <div className="main__inner">
        {/* Match Loader */}
        {/* <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
            backgroundColor: "rgba(0, 0, 0, 0.8)",
          }}
          open={isLoading}
        >
          <div className="flex flex-col items-center justify-center">
            <div className="relative">
              <div className="w-16 h-16 border-4 border-green-500 border-t-transparent rounded-full animate-spin mb-4"></div>
              <div className="w-12 h-12 border-4 border-teal-400 border-t-transparent rounded-full animate-spin absolute top-2 left-2"></div>
            </div>

            <div className="text-center">
              <h3 className="text-xl font-semibold text-white mb-2">
                {campaignStatus === "active"
                  ? "Finding Active Campaigns"
                  : "Loading Inactive Campaigns"}
              </h3>
              <div className="flex space-x-1 mt-4 justify-center">
                <div className="w-2 h-2 bg-green-500 rounded-full animate-bounce"></div>
                <div
                  className="w-2 h-2 bg-green-500 rounded-full animate-bounce"
                  style={{ animationDelay: "0.1s" }}
                ></div>
                <div
                  className="w-2 h-2 bg-green-500 rounded-full animate-bounce"
                  style={{ animationDelay: "0.2s" }}
                ></div>
              </div>
            </div>
          </div>
        </Backdrop> */}

        {!isLoading && isloaded && (
          <div className="opportunity">
            <div className="opportunity__table-title flex justify-start items-center mb-4 gap-5">
              <div className="flex items-center justify-start gap-3">
                <button
                  onClick={() => handleStatusChange("active")}
                  className={`px-6 py-3 rounded-full font-medium transition-all duration-200 ${
                    campaignStatus === "active"
                      ? "bg-gradient-to-r from-green-500 to-green-700 hover:bg-gradient-to-r hover:from-green-700 hover:to-green-500 text-white font-semibold shadow-md"
                      : "bg-white text-gray-600 hover:bg-gray-50 border border-gray-200"
                  }`}
                  disabled={isLoading}
                >
                  Active Campaigns
                </button>
                <button
                  onClick={() => handleStatusChange("inactive")}
                  className={`px-6 py-3 rounded-full font-medium transition-all duration-200 ${
                    campaignStatus === "inactive"
                      ? "bg-gradient-to-r from-green-500 to-green-700 hover:bg-gradient-to-r hover:from-green-700 hover:to-green-500 text-white font-semibold shadow-md"
                      : "bg-white text-gray-600 hover:bg-gray-50 border border-gray-200 "
                  }`}
                  disabled={isLoading}
                >
                  Inactive Campaigns
                </button>
              </div>
            </div>
            <TableContainer
              component={Paper}
              elevation={3}
              className="mb-3"
              sx={{ overflowX: "auto", width: "100%" }}
            >
              <Table>
                <TableHead className="bg-gray-200">
                  <TableRow>
                    <TableCell sx={{ py: 1 }}>Campaign Title</TableCell>
                    <TableCell sx={{ py: 1, textAlign: "left" }}>
                      Brand Name
                    </TableCell>
                    <TableCell sx={{ py: 1, textAlign: "left" }}>
                      Apply By
                    </TableCell>
                    {accountCount > 1 && (
                      <TableCell sx={{ py: 1, textAlign: "left" }}>
                        Account
                      </TableCell>
                    )}

                    <TableCell sx={{ py: 1, textAlign: "left" }}>
                      Deliver By
                    </TableCell>
                    <TableCell sx={{ py: 1, textAlign: "left" }}>
                      Compensation
                    </TableCell>
                    <TableCell sx={{ py: 1, textAlign: "center" }}>
                      Status
                    </TableCell>
                    <TableCell
                      sx={{ py: 1, textAlign: "center" }}
                      className="!pr-12"
                    >
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {opportunities.length > 0 ? (
                    opportunities.map((item, index) => {
                      return (
                        <OpportunitiesItem
                          key={index}
                          opportunity={item}
                          accountCount={accountCount}
                          openModal={() => {
                            setModalData(item);
                            setModal("opportunity");
                          }}
                          openApplyModal={openApplyModal}
                          isActive={campaignStatus === "active"}
                        />
                      );
                    })
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={accountCount > 1 ? "8" : "7"}
                        align="center"
                      >
                        {campaignStatus === "active"
                          ? "No active campaigns available at the moment. Check back later for new opportunities!"
                          : "No inactive campaigns available."}{" "}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <div className="opportunity__table-footer">
              <button
                className="button tertiary download"
                onClick={downloadCsv}
              >
                Download CSV {download}
              </button>
              {opportunities.length > 0 && (
                <Pagination
                  perPage={paginationData["per_page"]}
                  total={paginationData["total"]}
                  currentPage={paginationData["current_page"]}
                  totalPages={paginationData["total_pages"]}
                  onPaginate={onPaginate}
                />
              )}
            </div>

            <ModalOpportunitySecond
              open={modal === "opportunity"}
              onClose={() => setModal(null)}
              opportunity={modalData}
              openApplyModal={openApplyModal}
              accountCount={accountCount}
              closeProfileModal={closeProfileModal}
              isActive={campaignStatus === "active"}
            />
            {/* Apply Campaign Modal */}
            {showApplyModal && selectedCampaign && (
              <Dialog
                open={showApplyModal}
                onClose={closeApplyModal}
                maxWidth="md"
                fullWidth
                className="rounded-lg"
              >
                <DialogTitle className="bg-green-50 border-b border-green-200 pb-4">
                  <div className="text-xl font-semibold text-green-700">
                    Apply to {selectedCampaign.title} by{" "}
                    {selectedCampaign.brand_name}
                  </div>
                  {/* <div className="text-green-600 text-sm mt-1"></div> */}
                </DialogTitle>

                <DialogContent className="py-6 px-6">
                  <div className="mb-4">
                    <label
                      htmlFor="selectAccount"
                      className="block text-green-700 text-sm font-medium my-2"
                    >
                      Select Account <span className="text-red-500">*</span>
                    </label>
                    <AccountSelect
                      accounts={mediaAccounts}
                      selectedAccount={selectedAccount}
                      onChange={(account) => setSelectedAccount(account)}
                      disabled={isApplying}
                    />
                    {/* <select
                      id="selectAccount"
                      value={selectedAccount?.pt_user_id || ""}
                      onChange={(e) => {
                        const accountObj = mediaAccounts.find(
                          (acc) => acc.pt_user_id.toString() === e.target.value
                        );
                        console.log("Selected account:", accountObj);
                        setSelectedAccount(accountObj || null);
                      }}
                      disabled={isApplying}
                      className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 mb-4"
                    >
                      <option value="">Choose an account...</option>
                      {mediaAccounts.map((account) => (
                        <option
                          key={account.pt_user_id}
                          value={account.pt_user_id}
                        >
                          {account.social_media_code}{" "}
                          {account.handle && `- ${account.handle}`}
                        </option>
                      ))}
                    </select> */}

                    <label
                      htmlFor="proposedRate"
                      className="block text-green-700 text-sm font-medium my-2"
                    >
                      My Rate
                    </label>
                    <div className="flex gap-2">
                      <select
                        value={rateCurrency}
                        onChange={(e) => setRateCurrency(e.target.value)}
                        disabled={isApplying}
                        className="p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
                      >
                        <option value="USD">USD</option>
                        {/* <option value="EUR">EUR</option> */}
                        {/* <option value="GBP">GBP</option> */}
                      </select>
                      <input
                        id="proposedRate"
                        type="number"
                        value={proposedRate}
                        onChange={(e) => setProposedRate(e.target.value)}
                        placeholder="Enter amount"
                        disabled={isApplying}
                        className="flex-1 p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
                      />
                    </div>

                    <label
                      htmlFor="applicationNote"
                      className="block text-green-700 text-sm font-medium my-2"
                    >
                      Message to Brand <span className="text-red-500">*</span>
                    </label>
                    <TextField
                      id="applicationNote"
                      value={applicationNote}
                      onChange={(e) => setApplicationNote(e.target.value)}
                      placeholder="Excited to be part of this campaign. I believe my audience aligns perfectly..."
                      multiline
                      rows={5}
                      fullWidth
                      variant="outlined"
                      disabled={isApplying}
                      className="w-full"
                    />

                    <p className="mt-2 text-sm text-green-600">
                      Tell the brand why you're interested in this campaign and
                      how your audience would benefit.
                    </p>
                  </div>
                </DialogContent>

                <DialogActions className="px-6 py-4 bg-green-50 border-t border-green-200">
                  <button
                    onClick={closeApplyModal}
                    disabled={isApplying}
                    className={`mr-2 rounded-full py-2 px-4 border text-green-700 border-green-300 hover:bg-green-100 transition-colors duration-200 ${
                      isApplying
                        ? "opacity-50 cursor-not-allowed hover:bg-transparent"
                        : ""
                    }`}
                  >
                    Cancel
                  </button>

                  <button
                    onClick={handleApplyCampaign}
                    disabled={
                      isApplying || !applicationNote.trim() || !selectedAccount
                    }
                    className={`rounded-full py-2 px-4 text-white transition-colors duration-200 ${
                      isApplying || !applicationNote.trim() || !selectedAccount
                        ? "bg-green-400 cursor-not-allowed"
                        : "bg-green-600 hover:bg-green-700"
                    }`}
                  >
                    {isApplying ? "Applying..." : "Apply"}
                  </button>
                </DialogActions>
              </Dialog>
            )}
            {showProfileIncompleteModal && (
              <Dialog
                open={showProfileIncompleteModal}
                onClose={closeProfileModal}
                maxWidth="sm"
                fullWidth
                className="rounded-2xl"
              >
                {/* --- Header --- */}
                <DialogTitle className="bg-white border-b border-green-200 px-6 pt-6 pb-3 rounded-t-2xl">
                  <div className="text-2xl font-semibold text-green-700">
                    Complete Your Profile
                  </div>
                </DialogTitle>

                {/* --- Body --- */}
                <DialogContent className="bg-white px-6 py-6">
                  <div className="text-green-700 text-base leading-relaxed mt-4">
                    You haven’t completed your public profile yet. Please
                    complete your profile to be eligible to apply for campaigns.
                  </div>
                </DialogContent>

                {/* --- Footer --- */}
                <DialogActions className="px-6 py-5 bg-green-50 border-t border-green-200 rounded-b-2xl">
                  <button
                    onClick={closeProfileModal}
                    className="mr-3 rounded-full py-2 px-5 border text-green-700 border-green-400 hover:bg-green-100 transition-all duration-200 font-medium"
                  >
                    Cancel
                  </button>

                  <button
                    onClick={() => navigate(ROUTES.INFLUENCER.PUBLIC_PROFILE)}
                    className="rounded-full py-2 px-5 bg-green-600 hover:bg-green-700 text-white font-medium shadow-sm transition-all duration-200"
                  >
                    Complete Profile
                  </button>
                </DialogActions>
              </Dialog>
            )}

            {toastList && <Toast list={toastList} setList={setToastList} />}
          </div>
        )}
      </div>
    </div>
  );
}
